import React, { Component } from "react"
import { graphql } from "@apollo/client/react/hoc"
import { Row, Col, Nav, NavItem, NavLink, Container, TabContent, TabPane, UncontrolledTooltip } from "reactstrap"
import gql from "graphql-tag"

import Loader from "../../Material/Loader"
import OverviewTab from "./MemberDetailsTab/OverviewTab"
import HistoryTab from "./MemberDetailsTab/HistoryTab"
import withApolloClient from "../../withApolloClient"

import "./MemberDetails.css"

const MemberQuery = gql`
query Member($id: ID!) {
    member(id: $id) {
    id
    pk
    user {
        isActive
        firstName
        lastName
    }
    tenant {
        name
        logoImage
    }
    defaultBranch {
        name
    }
    }
}
`

const TABS = [
    { id: "#overview", label: "Overview" },
    { id: "#history", label: "History" },
]

class MemberDetails extends Component {
    state = {
        activeTab: "#overview",
        renderedTabs: ["#overview"],
    }

    componentDidMount() {
        const hash = window.location.hash
        if (TABS.some(t => t.id === hash)) {
            this.setState({ activeTab: hash, renderedTabs: [hash] })
        } else {
            window.location.hash = "#overview"
        }
    }

    toggleTab = (tab) => {
        if (!this.state.renderedTabs.includes(tab)) {
            this.setState({
                renderedTabs: [...this.state.renderedTabs, tab],
            })
        }
        this.setState({ activeTab: tab })
        window.location.hash = tab
    }

    render() {
        const { member, loading } = this.props
        if (loading) return <Loader />
        if (!member) return null

        const isActive = member.user?.isActive

        return (
            <Container fluid className="member-details-page">
                <div className="member-header">
                    <div className="member-header-actions">
                        <div className="member-hash-badge">#{member.pk}</div>
                    </div>
                    <Row className="align-items-center">
                        <Col md="12" className="member-header-main">
                            <div className="member-header-title">
                                <img src={member.tenant.logoImage} alt={member.tenant.name} className="member-header-icon" />
                                <div className="member-header-text">
                                    <div className="member-title-row">
                                        <div className="member-title">
                                            {member.user.firstName || "-"} {member.user.lastName || "-"}
                                        </div>
                                        <span className={`member-status-tag ${isActive ? "is-active" : "is-inactive"}`}>
                                            {isActive ? "Active" : "Inactive"}
                                        </span>
                                    </div>
                                    <div className="member-subtitle">
                                        <span className="member-pill tenant" id={`tenant-pill-${member.pk}`}>
                                            {member.tenant.name}
                                            <UncontrolledTooltip target={`tenant-pill-${member.pk}`}>Tenant Name</UncontrolledTooltip>
                                        </span>
                                        {member.defaultBranch?.name && (
                                            <span className="member-pill branch" id={`branch-pill-${member.pk}`}>
                                                {member.defaultBranch.name}
                                                <UncontrolledTooltip target={`branch-pill-${member.pk}`}>Default Branch</UncontrolledTooltip>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Nav className="member-tabs">
                    {TABS.map(tab => (
                        <NavItem key={tab.id}>
                            <NavLink
                                className={this.state.activeTab === tab.id ? "active" : ""}
                                onClick={() => this.toggleTab(tab.id)}
                            >
                                {tab.label}
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
                <div className="member-content">
                    <TabContent activeTab={this.state.activeTab}>
                        {this.state.renderedTabs.includes("#overview") && (
                            <TabPane tabId="#overview">
                                <OverviewTab memberId={member.id} />
                            </TabPane>
                        )}
                        {this.state.renderedTabs.includes("#history") && (
                            <TabPane tabId="#history">
                                <HistoryTab memberId={member.id} />
                            </TabPane>
                        )}
                    </TabContent>
                </div>
            </Container>
        )
    }
}

export default graphql(MemberQuery, {
    options: props => ({
        fetchPolicy: "network-only",
        variables: { id: props.params.id },
    }),
    props: ({ data }) => ({
        member: data.member,
        loading: data.loading,
    }),
})(withApolloClient(MemberDetails))
